import { sk } from './sk';
import type { SupportChatLanguage, SupportChatResources } from './types';

/**
 * Slovak ships inside the widget bundle; Czech and English are separate chunks that
 * main.ts loads (loadLanguage) before mounting, so a page view downloads only its own pack.
 */
const packs: Partial<Record<SupportChatLanguage, SupportChatResources>> = { sk };

/** Loads a pack that is not bundled; resolves once createTranslator can use it. */
export async function loadLanguage(language: SupportChatLanguage): Promise<void> {
	if (packs[language]) {
		return;
	}

	packs[language] = language === 'cs' ? (await import('./cs')).cs : (await import('./en')).en;
}

/** sk / cs as such; every other page language (en, de, hu, pl, …) gets English, not Slovak. */
export function resolveLanguage(code: string | null | undefined): SupportChatLanguage {
	const c = (code ?? '').toLowerCase().slice(0, 2);
	if (c === 'sk' || c === 'cs') {
		return c;
	}

	return c === '' ? 'sk' : 'en';
}

/** Returns a translate function; a missing key falls back to English (when loaded), then Slovak. */
export function createTranslator(language: SupportChatLanguage): (key: string) => string {
	const pack = packs[language] ?? sk;
	return (key: string) => pack[key] ?? packs.en?.[key] ?? sk[key] ?? key;
}
